"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.center = exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ei0607b0"
} : {
  target: "ei0607b0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1593lot",
  styles: "display:grid;grid-template-rows:1fr;grid-row-gap:0.3em"
} : {
  name: "1593lot",
  styles: "display:grid;grid-template-rows:1fr;grid-row-gap:0.3em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const center = exports.center = process.env.NODE_ENV === "production" ? {
  name: "1wg53za",
  styles: "justify-items:center"
} : {
  name: "2nn238-center",
  styles: "justify-items:center;label:center;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};